import { useFlag } from '@unleash/proxy-client-react';
import { notification } from 'antd';
import { useEffect, useState } from 'react';

import { ExclamationMarkSvg } from '../assets/icons';
import { IconWrapper } from '../components/_atoms/IconWrapper';

const useShowMaintanancePopup = () => {
  const showMaintananceToast = useFlag('showMaintananceToast');
  const [hasShown, setHasShown] = useState(false);
  useEffect(() => {
    if (showMaintananceToast && !hasShown) {
      notification.info({
        placement: 'top',
        top: 70,
        message:
          'We are currently undergoing maintenance, Curipod might be slow or unresponsive. We apologize for the inconvenience.',
        duration: 0,
        icon: (
          <IconWrapper height="50px" width="30px">
            {' '}
            <ExclamationMarkSvg />
          </IconWrapper>
        ),
      });
      setHasShown(true);
    }
  }, [hasShown, showMaintananceToast]);
};
export default useShowMaintanancePopup;
